import React from "react";
import Link from "next/link";
// import LazyImage from "../../molecules/layout/Images/LazyImage";
import Image from "@image";
// import getImageUrlWithCdnPrefix from "../../../utils/getImageUrlWithCdnPrefix";
import rgbDataURL from "../../../utils/rgbDataURL";

function BlogCategories(props) {
    return (
        <>
            <div className="container">
                <div className="row justify-content-start pt-4">
                    <div className="col-12 col-lg-8 col-md-8">
                        <h1 className="font-size-34 mb-3">Inuua Blog</h1>
                        <p className="lead font-size-12 text-muted">
                            Pick a category from below and learn everything you
                            need to know while building your home
                        </p>
                    </div>
                </div>
            </div>
            <section className="section section-lg py-6 bg-soft">
                <div className="container z-2">
                    <div className="row justify-content-center">
                        {props.blogCategories &&
                            props.blogCategories.map((category) => (
                                <div className="col-12 col-lg-4 mb-5">
                                    <Link
                                        href={`/blog/categories/${category.slug}`}
                                    >
                                        <a>
                                            <div className="card shadow-soft border-light">
                                                <div className="card-header p-0 custom-header-img">
                                                    <Image
                                                        alt={`Blog category ${category.name}`}
                                                        className="card-img-top rounded-top"
                                                        height="216"
                                                        src={
                                                            category.category_image_file
                                                        }
                                                        width="347"
                                                        quality={50}
                                                        layout="responsive"
                                                        placeholder="blur"
                                                        blurDataURL={rgbDataURL()}
                                                    />
                                                </div>
                                                <div className="card-body py-2">
                                                    <div className="pl-0 pt-4">
                                                        <span className="font-size-15 font-weight-bold text-dark">
                                                            {category.name}
                                                        </span>
                                                    </div>
                                                    <div className="pl-0 pt-2 pb-1">
                                                        <p className="text-gray-700">
                                                            {
                                                                category.description
                                                            }
                                                        </p>
                                                    </div>
                                                    <div className="pl-0 pb-3">
                                                        <div className="btn-cont">
                                                            <Link
                                                                href={`/blog/categories/${category.slug}`}
                                                            >
                                                                <a>
                                                                    Explore
                                                                    Category
                                                                </a>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                    </Link>
                                </div>
                            ))}
                    </div>
                </div>
            </section>
        </>
    );
}

export default BlogCategories;
